var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.layout)?[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }